/**
 * Form field normalizers - migrated from jl-design-system/form/normalizers/restrictInput
 * These functions are used to restrict and normalize user input in form fields
 */

/**
 * Restricts input to ASCII extended characters (printable ASCII characters)
 * Includes letters, numbers, spaces, and common punctuation
 * @param {string} value - The input value
 * @returns {string} - The normalized value containing only ASCII extended characters
 */
export const asciiExtendedOnly = (value) => {
  if (!value) return value;
  // Allow printable ASCII characters (32-126) including space, letters, numbers, and punctuation
  return value.replace(/[^\x20-\x7E]/g, '');
};
